export default {
  activeRoomId: state => state.activeRoomId,
  isConnected: state => !!state.connected,

  rooms: state => state.rooms || [],

  activeRoom: state => {
    const rid = state.activeRoomId != null ? String(state.activeRoomId) : null
    const rooms = state.rooms || []
    return rooms.find(r => String(r.id) === rid) || null
  },

  activeRoomMessages: state => {
    const rid = state.activeRoomId != null ? String(state.activeRoomId) : null
    if (!rid) return []
    return (state.messagesByRoom && state.messagesByRoom[rid])
      ? state.messagesByRoom[rid]
      : []
  },

  unreadCount: state => {
    // total não lidas em todas as salas
    const rooms = state.rooms || []
    return rooms.reduce((sum, r) => sum + (+r.unreadCount || 0), 0)
  },

  isChatOpen: state => !!(state.ui && state.ui.isOpen),

  isLoadingRooms: state => !!(state.loading && state.loading.rooms),
  isLoadingMessages: state => !!(state.loading && state.loading.messages),

  searchResults: state => state.searchResults || []
}



// WEBPACK FOOTER //
// ./src/plugins/chat-plugin/store/getters.js